import DAO from "../../DAO/DAO";
import HTTPClient from "../../services/AxiosClient";
import Services from "../../services/Services";
import config from "../../config";
import router from "../../routers";

import Vue from "vue";

class TokenTimer {
	constructor() {
		this._Vue = new Vue();
		this._stopwatch = null;
		this.timeout = null;
	}

	_getValidateTokenInDAO() {
		return DAO.user.getProperty("validadeToken");
	}

	_getTokenRefreshTimeInDAO() {
		return DAO.getProperty("tokenRefreshTime");
	}

	_getTimeToAlertInDAO() {
		return DAO.getProperty("timeToAlert");
	}

	_getIsStartedInDAO() {
		return DAO.getProperty("isStarted");
	}

	_setIsStartedInDAO(value) {
		DAO.setProperty("isStarted", value);
	}

	_getIsShowAlertInDAO() {
		return DAO.getProperty("isShowAlert");
	}

	_setIsShowAlertInDAO(value) {
		DAO.setProperty("isShowAlert", value);
	}

	_minutosParaMilisegundos(minutos) {
		return minutos * 60000;
	}

	_timeoutApresentation(timeout) {
		if (timeout < 60000) {
			return `${Math.trunc(timeout / 1000)} segundos`;
		}

		if (timeout > 60000) {
			const secondsInMilli = timeout % 60000;
			const minutesInMilli = timeout - secondsInMilli;

			if (secondsInMilli === 0) {
				return `${Math.trunc(minutesInMilli / 60000)}`;
			}

			const minutes = Math.trunc(minutesInMilli / 60000);
			const seconds = Math.trunc(secondsInMilli / 1000);

			if (seconds > 0) {
				return `${minutes} minutos e ${seconds} segundos`;
			}

			return `${minutes} minutos`;
		}
	}

	_getTimeout(time, timeAlert) {
		let timeout = null;

		const timeEnd = this._getTokenRefreshTimeInDAO();

		const timeNow = new Date().getTime();

		if (!timeEnd) {
			timeout = time - timeAlert;
		} else {
			timeout = parseInt(timeEnd, 10) - timeNow;
		}

		return this._timeoutApresentation(timeout);
	}

	_clearControlTime() {
		DAO.removeProperty("tokenRefreshTime");
		DAO.removeProperty("timeToAlert");
	}

	_clearControlVariables() {
		DAO.removeProperty("isStarted", false);
		DAO.removeProperty("isShowAlert", false);
	}

	_setControlTime(timeToAlert, timeEnd) {
		DAO.setProperty("tokenRefreshTime", timeEnd.toString());
		DAO.setProperty("timeToAlert", timeToAlert.toString());
	}

	_getTimeToAlert(time, percentageTotalTimeForAlertDisplayed) {
		if (percentageTotalTimeForAlertDisplayed <= 0) {
			percentageTotalTimeForAlertDisplayed = 10;
		}

		return time - time / percentageTotalTimeForAlertDisplayed;
	}

	_deleteAlert() {
		const alerts = document.querySelectorAll(".vs-notifications");
		if (alerts) {
			alerts.forEach(alert =>
				alert.parentNode.removeChild(alert)
			)
		}
	}

	_logout() {
		setTimeout(() => {
			router.push({ name: 'logout' });
			this._Vue.$vs.notify({
				title: "Sessão expirada",
				text: "Sua sessão expirou por falta de atividade. Faça o login novamente.",
				color: "danger",
				fixed: true,
				icon: "query_builder",
			});
		}, 0);
	}

	_reset(time, percentageTotalTimeForAlertDisplayed) {
		this._deleteAlert();
		clearTimeout(this._stopwatch);
		this._clearControlVariables();
		this._clearControlTime();
		this._tokenUpdateTimer(time, percentageTotalTimeForAlertDisplayed);
	}

	_refreshToken() {
		const token = DAO.token.get();
		Services.AutenticacaoService.usuarioAutenticado(token);
	}

	_getStopwatch(
		time,
		timeToAlert,
		auxTimeToAlert,
		timeEnd,
		percentageTotalTimeForAlertDisplayed
	) {
		return setInterval(() => {
			const timeNow = new Date().getTime();

			if (timeNow > timeToAlert && timeNow < timeEnd) {
				this.timeout = this._getTimeout(time, auxTimeToAlert);

				let isShowAlert = this._getIsShowAlertInDAO();

				if (!isShowAlert) {
					this._Vue.$vs.notify({
						title: "Sua sessão vai expirar",
						text: "Clique aqui para evitar o encerramento.",
						color: "warning",
						fixed: true,
						icon: "query_builder",
						click: () => {
							this._refreshToken();

							this._reset(
								time,
								percentageTotalTimeForAlertDisplayed
							);
						}
					});

					this._setIsShowAlertInDAO(true);
				}
			} else if (timeNow >= timeEnd) {
				this._deleteAlert();
				this._logout();
				clearInterval(this._stopwatch);
			}
		}, 1);
	}

	_tokenUpdateTimer(time, percentageTotalTimeForAlertDisplayed) {
		if (time <= 0) {
			return null;
		}
		let isStarted = this._getIsStartedInDAO();

		if (!isStarted) {
			this._setIsStartedInDAO(true);

			const timeNow = new Date().getTime();
			let auxTimeToAlert = 0;
			let timeEnd = this._getTokenRefreshTimeInDAO();
			let timeToAlert = this._getTimeToAlertInDAO();

			if (!timeEnd && !timeToAlert) {
				timeEnd = timeNow + time;

				timeToAlert = this._getTimeToAlert(
					time,
					percentageTotalTimeForAlertDisplayed
				);
				auxTimeToAlert = timeToAlert;
				timeToAlert += timeNow;

				this._setControlTime(timeToAlert, timeEnd);
			} else {
				timeEnd = parseInt(timeEnd, 10);
				timeToAlert = parseInt(timeToAlert, 10);
			}

			this._stopwatch = this._getStopwatch(
				time,
				timeToAlert,
				auxTimeToAlert,
				timeEnd,
				percentageTotalTimeForAlertDisplayed
			);
		}
	}

	startStopwatch() {
		const isAuthenticated = !this._Vue.$permissions.can("public");
		if (isAuthenticated) {
			const time = this._getValidateTokenInDAO();

			if (time) {
				this._reset(
					this._minutosParaMilisegundos(time),
					config.percentageTotalTimeForAlertDisplayed
				);
			}
		} else {
			clearInterval(this._stopwatch);
			this._deleteAlert();
		}
	}
}


const tokenTimer = new TokenTimer(Vue);

HTTPClient.interceptors.request.use(
	async config => {
		try {
			tokenTimer.startStopwatch();
		} catch (error) {
			console.error(error);
		}

		return config;
	},
	error => {
		// I cand handle a request with errors here
		return Promise.reject(error);
	}
);
